enum Routes {
  Analytics = "/analytics",
  Dashboard = "/sn/dashboards/:id",
  Login = "/login",
  ResetPassword = "/reset-password",
  MFAChallenge = "/mfa-challenge"
}

export default Routes;
